import css from './PDFViewFrame.module.css';

export const PDFViewFrame: React.FC = () => <div className={css.frame} />;
